export default "__VITE_ASSET__CSsw_Dvm__"